import { render, staticRenderFns } from "./BatchCreate.vue?vue&type=template&id=7df4dfe6"
import script from "./BatchCreate.vue?vue&type=script&lang=js"
export * from "./BatchCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports